import {
  createContext,
  useContext,
  useState,
  useMemo
} from "react";

// API
import {
  useGetCalonMa,
  useGetTraining,
  useGetAllTrainingAndBatch,
  useGetJuniorMa,
  useGetMa
} from 'api/training/query';
import dayjs from 'dayjs';

const ListEducation = [
  {
    label: "SMA",
    value: "SMA"
  },
  {
    label: "D3",
    value: "D3"
  },
  {
    label: "S-1",
    value: "S-1"
  },
  {
    label: "S-2",
    value: "S-2"
  },
  {
    label: "S-3",
    value: "S-3"
  }
]

export const TrainingCtx = createContext();

export const TrainingProvider = ({ children }) => {
  const [tab, setTab] = useState("training"); //training, jma, ma

  const [paramsListCalonMa, setParamsListCalonMa] = useState({
    q: "",
    page: 1,
    _limit: 30
  })

  const [paramsListJma, setParamsListJma] = useState({
    q: "",
    page: 1,
    _limit: 30,
  })

  const [paramsListMa, setParamsListMa] = useState({
    q: "",
    page: 1,
    _limit: 30,
    accelerated_training: true
  })
  
  const { data: listCalonMa, refetch: refetchCalonMa, isFetching: isFetchingCalonMA, fetchNextPage } = useGetCalonMa({ params: paramsListCalonMa });
  const { data: listJma, refetch: refetchJma, isFetching: isFetchingJma, fetchNextPage: fetchNextPageJma } = useGetJuniorMa({ params: paramsListJma, enabled: tab === "jma" });
  const { data: listMa, refetch: refetchMa, isFetching: isFetchingMa, fetchNextPage: fetchNextPageMa } = useGetMa({ params: paramsListMa, enabled: tab === "ma" });

  const { data: listTraining, refetch: refetchListTraining, isFetching: isFetchingListTraining } = useGetTraining({});
  const { data: listAllTrainingAndBatches, refetch: refetchAllTrainingAndBatch, isFetching: isFetchingTrainingAndBatch } = useGetAllTrainingAndBatch({});

  const isFreeBatchOpen = useMemo(() => {
    if (!listAllTrainingAndBatches?.data?.data?.length) return false;
    
    const newList = listAllTrainingAndBatches?.data?.data?.map(l => {
      if (!!l?.batches?.length) {
        return { ...l, batches: l?.batches.filter(b => b?.batch_status === "active" && dayjs().isBefore(b?.end_date)) }
      }
      return l
    })

    return !!newList?.find(d => (d?.training_type === "ooc" || d.training_type === "up") && !!d?.batches?.length)
  }, [listAllTrainingAndBatches?.data?.data])

  const isPaidBatchOpen = useMemo(() => {
    if (!listAllTrainingAndBatches?.data?.data?.length) return false;

    const newList = listAllTrainingAndBatches?.data?.data?.map(l => {
      if (!!l?.batches?.length) {
        return {
          ...l, batches: l?.batches.filter(b => {
            return b?.batch_status === "active" && dayjs().isBefore(b?.end_date)
          })
        }
      }
      return l
    })

    return !!newList?.find(d => d?.training_type === "create21" && !!d?.batches?.length)
  }, [listAllTrainingAndBatches?.data?.data])

  const isJKMarketing = useMemo(() => {
    if (!listAllTrainingAndBatches?.data?.data?.length) return false;

    const newList = listAllTrainingAndBatches?.data?.data?.map(l => {
      if (!!l?.batches?.length) {
        return {
          ...l, batches: l?.batches.filter(b => {
            return b?.batch_status === "active" && dayjs().isBefore(b?.end_date)
          })
        }
      }
      return l
    })

    return !!newList?.find(d => (d?.training_type === "jk_marketing" || d?.training_type === "ta") && !!d?.batches?.length)
  }, [listAllTrainingAndBatches?.data?.data])

  const refetchAll = () => {
    refetchCalonMa()
    refetchJma()
    refetchMa()
    refetchListTraining()
    refetchAllTrainingAndBatch()
  }

  return (
    <TrainingCtx.Provider value={{
      tab,
      setTab,
      listCalonMa,
      listJma,
      listMa,
      listTraining,
      ListEducation,
      listAllTrainingAndBatches,

      // Params
      paramsListCalonMa,
      setParamsListCalonMa,
      paramsListJma,
      setParamsListJma,
      paramsListMa,
      setParamsListMa,
      refetchCalonMa,
      refetchJma,
      refetchMa,

      refetchAll,
      isFreeBatchOpen,
      isPaidBatchOpen,
      isJKMarketing,
      fetchNextPage,
      fetchNextPageJma,
      fetchNextPageMa,
      
      isLoading: isFetchingCalonMA || isFetchingJma || isFetchingMa || isFetchingListTraining || isFetchingTrainingAndBatch
    }}>
      {children}
    </TrainingCtx.Provider>
  )
}

export const useTrainingCtx = () => {
  const ctx = useContext(TrainingCtx);

  if (!ctx) {
    throw new Error("useTrainingCtx must be used within the TrainingProvider");
  }

  return ctx;
};
